import React from "react";
import PropTypes from "prop-types";

import PrintDocumentInfoFabricator from "./printDocumentInfoFabricator";
import {IS_AS_WORK_ORDER, IS_DEALER_FLOW} from "../../../config";
import PrintDocumentInfoCustomer from "./printDocumentInfoCustomer";
import PrintDocumentInfoHomeDepotFields from "./printDocumentInfoHomeDepotFields";

export const getAddressFromObject = (userInfo, withAddress1 = false) => {
  if (!userInfo) {
    return ""
  }
  let displayAddress = withAddress1 ? userInfo.address1 || "" : "";
  ["city", "state", "postal"].forEach(property => { // 1) city 2) provence 3) postal
    let value = userInfo[property];
    if (property === "state" && !value && userInfo["provence"]) {
      value = userInfo["provence"];
    } else if (property === "postal" && !value && userInfo["zip"]) {
      value = userInfo["zip"];
    }
    if (value) {
      if (displayAddress) {
        displayAddress += ", "
      }
      displayAddress += value
    }
  });
  return displayAddress
}

const PrintDocumentInfo = (props) => {
  const {styles, userInfo, fabricatorData, assignQuotePopupCustomer, employeeSelected, messages, paymentState,
    isContractSign, printState, isHomeDepotReceipt} = props;

  const {View, Text} = window.ReactPdfRenderer;

  const hasNewBillingInfo = paymentState.billingAddress && paymentState.billingAddress.address1;
  const customerHasBillingAddress = hasNewBillingInfo ? (["address1", "city", "postal"].some(key => {
    return paymentState.billingAddress[key] !== paymentState.shippingAddress[key]
  })) : userInfo.shipping && (["address1", "city", "postal"].some(key => {
    return userInfo.shipping[key] && (userInfo[key] !== userInfo.shipping[key])
  }));
  let billingAddress = "";
  if (customerHasBillingAddress) {
    billingAddress = getAddressFromObject( hasNewBillingInfo ? paymentState.billingAddress : userInfo.shipping);
  }
  const hasHoveDepotInputs = isHomeDepotReceipt;
  const threeColumns = (employeeSelected || (customerHasBillingAddress && !fabricatorData.isCaesarStone) || hasHoveDepotInputs)
    && !fabricatorData.isAmericanStandard && !IS_DEALER_FLOW;

  console.log("userInfo.shipping", userInfo, paymentState);

  return (
    <View style={styles.main}>
      <PrintDocumentInfoCustomer assignQuotePopupCustomer={assignQuotePopupCustomer}
                                 userInfo={userInfo}
                                 messages={messages}
                                 styles={styles}
                                 paymentState={paymentState}
                                 fabricatorData={fabricatorData}
                                 threeColumns={!!threeColumns}
                                 hasHoveDepotInputs={!!hasHoveDepotInputs}
                                 isDealerFlow={IS_DEALER_FLOW}/>
      {threeColumns ? (
        <View style={[styles.section, styles.sectionCenter, hasHoveDepotInputs ? styles.sectionHomeDepotCenter : null]}>
          {hasHoveDepotInputs ? <PrintDocumentInfoHomeDepotFields fabricatorData={fabricatorData}
                                                                  threeColumns={!!threeColumns}
                                                                  isContractSign={isContractSign}
                                                                  printState={printState}
                                                                  styles={styles}
                                                                  messages={messages}/> : null}
          {!fabricatorData.isCaesarStone && customerHasBillingAddress
            ? <Text style={styles.mainTitle}>{messages["receipt.mainInfo.billingAddress"]}</Text>
            : null}
          {!fabricatorData.isCaesarStone && customerHasBillingAddress && (paymentState.billingAddress.name || paymentState.billingAddress.fullName)
            ? <Text style={styles.mainText}>{paymentState.billingAddress.name || paymentState.billingAddress.fullName}</Text>
            : null}
          {!fabricatorData.isCaesarStone
          && customerHasBillingAddress && (hasNewBillingInfo ? paymentState.billingAddress.address1 : userInfo.shipping.address1)
            ? <Text style={styles.mainText}>{paymentState.billingAddress.address1 || userInfo.shipping.address1}</Text>
            : null}
          {!fabricatorData.isCaesarStone && customerHasBillingAddress && billingAddress
            ? <Text style={styles.mainText}>{billingAddress}</Text>
            : null}
          {employeeSelected ? (
            <Text style={!fabricatorData.isCaesarStone && customerHasBillingAddress && (billingAddress || userInfo.shipping.address1)
              ? [styles.mainTitle, styles.mainTextEmail] : styles.mainTitle}>
              {messages["receipt.mainInfo.salesPerson"]}
            </Text>
          ) : null}
          {employeeSelected ? <Text style={styles.mainText}>{employeeSelected.fullName}</Text> : null}
        </View>
      ) : null}
      {IS_AS_WORK_ORDER || IS_DEALER_FLOW ? null : <PrintDocumentInfoFabricator fabricatorData={fabricatorData}
                                                              threeColumns={!!threeColumns}
                                                              hasHoveDepotInputs={!!hasHoveDepotInputs}
                                                              styles={styles}
                                                              messages={messages}/>}
      {IS_DEALER_FLOW ? <PrintDocumentInfoCustomer assignQuotePopupCustomer={assignQuotePopupCustomer}
                                                   userInfo={userInfo}
                                                   messages={messages}
                                                   styles={styles}
                                                   paymentState={paymentState}
                                                   fabricatorData={fabricatorData}
                                                   threeColumns={!!threeColumns}
                                                   hasHoveDepotInputs={!!hasHoveDepotInputs}
                                                   isStoreInformation={true}
                                                   isDealerFlow={false}/> : null}
    </View>
  )
};

PrintDocumentInfo.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  styles: PropTypes.object.isRequired,
  isHomeDepotReceipt: PropTypes.bool,
};

export default PrintDocumentInfo
